<template>
  <div class="container">
    <!-- 菜单导航 -->
    <Menu></Menu>
    <!-- banner -->
    <Banners></Banners>
    <!-- 公开课 -->
    <Lecture></Lecture>
    <!-- 热门课程 -->
    <Popular></Popular>
    <!-- 作品展示 -->
    <Exhibition></Exhibition>
    <!-- 学习模式 -->
    <Models></Models>
    <!-- 教学团队 -->
    <Teaching></Teaching>
   
    <!-- 资讯中心 -->
    <Information></Information>
    <!-- 底部链接 -->
    <Footer :footShow="footShow"></Footer>
  </div>
</template>

<script>
import Menu from '@/components/view/Menu'
import Banners from '@/components/view/Homes/banners.vue'
import Teaching from '@/components/view/Homes/teaching.vue'
import Exhibition from '@/components/view/Homes/exhibition.vue'
import Information from '@/components/view/Homes/information.vue'
import Footer from '@/components/view/Footer'
import Lecture from './view/Homes/lecture.vue'
import Popular from './view/Homes/popular.vue'
import Models from './view/Homes/models.vue'
export default {
  name: 'home',
  components: {
    Menu,
    Banners,
    Teaching,
    Exhibition,
    Information,
    Footer,
    Lecture,
    Popular,
    Models
  },
  data () {
    return {
      footShow: true
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Home.vue